import * as React from "react";
import { BrowserRouter } from "react-router-dom";

import AuthStore from "src/context/AuthStore";

import OrganizationAPI from "./admin/Organization/API/OrganizationAPI";

import AuthContext from "./context/AuthContext";
import { Spinner } from "./components/common";
import { LoggedIn } from "./common/LoggedIn";
import { ToastContainer } from "react-toastify";
import { Route, Switch } from "react-router-dom";
import NeurapulsePage from "./neurapulse/neurapulsePage";
import PublicRoutes from "./common/PublicRoutes";
import { ZohoDeskPlugin } from "./zoho-desk-plugin";
import AppWrapper from "./AppWrapper";

interface IProps {}

interface IState {
	currentDataset: DatasetDTO;
	currentOrganization: OrganizationDTO;
}

class App extends React.Component<IProps, IState> {
	constructor(props: any) {
		super(props);
		this.state = {
			currentDataset: {},
			currentOrganization: {},
		};
	}

	static context = AuthContext;

	public render() {
		return (
			<AppWrapper>
				<ToastContainer autoClose={1500} />
				<AuthStore>
					<AuthContext.Consumer>
						{({ loading, loggedIn }) => {
							if (loading) return <Spinner />;
							return (
								<BrowserRouter>
									<ZohoDeskPlugin />
									{loggedIn ? (
										<Switch>
											<Route path="/neurapulse" component={NeurapulsePage} />
											<LoggedIn
												{...this.state}
												updateCurrentDataset={this.updateCurrentDataset}
												updateCurrentOrganization={
													this.updateCurrentOrganization
												}
											/>
										</Switch>
									) : (
										<PublicRoutes />
									)}
								</BrowserRouter>
							);
						}}
					</AuthContext.Consumer>
				</AuthStore>
			</AppWrapper>
		);
	}

	private updateCurrentDataset = (dataset: DatasetDTO) => {
		localStorage.setItem("currentDatasetName", dataset.name!);
		return new Promise((resolve) => {
			this.setState(
				{
					currentDataset: dataset,
				},
				() => resolve
			);
		});
	};

	private updateCurrentOrganization = async (organizationId: number) => {
		if (
			this.state.currentOrganization.id !== organizationId &&
			typeof organizationId === "number" &&
			!Number.isNaN(organizationId)
		) {
			const currentOrganization =
				await OrganizationAPI.getClientSiteOrganization({ organizationId });
			this.setState({ currentOrganization });
		}
	};
}

export default App;
